import { useEffect, useState } from 'react';
import { Accordion, Button, Card, Col, Row } from 'react-bootstrap';
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ErrorLayout from '../../components/Error/ErrorLayout';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import { billingInformationsState } from '../../features/billingInformations/billingInformationsSlice';
import BillingInformationForm from '../../features/billingInformations/components/BillingInformationForm';
import ListInvoice from '../../features/invoices/components/ListInvoice';
import PaymentMethodDisplay from '../../features/paymentMethod/components/PaymentMethodDisplay';
import PaymentMethodForm from '../../features/paymentMethod/components/PaymentMethodForm';
import { paymentMethodState } from '../../features/paymentMethod/paymentMethodSlice';
import PlanRecap from '../../features/planUsage/components/PlanRecap';
import PlanUsageSummary from '../../features/planUsage/components/PlanUsageSummary';
import { usePlanUsage } from '../../features/planUsage/hooks/usePlanUsage';
import { useAppSelector } from '../../hooks/redux/hooks';

const Billing = () => {
    const [, planUsageDisplay] = usePlanUsage();
    const { billingInformation } = useAppSelector(billingInformationsState);
    const { toastList, addToast } = useToaster();
    const [stateIsFormDirty, setStateIsFormDirty] = useState(false);

    const { informations,
        isUpdated: isBillingInformationUpdated,
        isSuccess: isBillingInformationSuccess,
        isLoading: isBillingInformationLoading,
        error,
        isError: isBillingInformationError
    } = billingInformation;

    useEffect(() => {
        // Handle errors back from server on vatNumber
        if (error && informations) {
            addToast({ idx: 'billingInfoError', theme: 'danger', autohide: false, title: 'Error', body: () => <ErrorLayout error={error} /> });
        }

        if (isBillingInformationUpdated && isBillingInformationSuccess) {
            addToast({ idx: 'billingInfoUpdated', theme: 'success', title: 'Success', body: () => (<>Successsfully updated your billing informations !</>) });
            setStateIsFormDirty(false)
        }
    }, [informations, isBillingInformationError, isBillingInformationUpdated, isBillingInformationSuccess, error?.message])


    const { payment } = useAppSelector(paymentMethodState);

    useEffect(() => {
        if (payment.paymentStatus === 'updatedPaymentMethod') {
            addToast({ idx: 'paymentMethodUpdated', theme: 'success', title: 'Success', body: () => (<>Successsfully updated your payment method !</>) });
        }
    }, [payment]);

    return (
        <>
            <DashboardPage heading="Billing">
                <PlanUsageSummary />

                <PlanRecap />

                {planUsageDisplay && planUsageDisplay.id !== process.env.REACT_APP_SMASH_API_TRIAL && <Card className="my-3">
                    <Card.Header as="h5">Bank information</Card.Header>
                    <Card.Body>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <PaymentMethodDisplay />
                                </Accordion.Header>
                                <Accordion.Body>
                                    <PaymentMethodForm />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card.Body>
                </Card>}

                <Card className="my-3">
                    <Card.Header as="h5">Billing information</Card.Header>
                    <Card.Body>
                        <BillingInformationForm informationFormId="information-billing" isFormDirty={(isDirty) => setStateIsFormDirty(isDirty)} />
                        {!isBillingInformationLoading && <Row>
                            <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                                <Button type="submit" disabled={!stateIsFormDirty} form="information-billing">Save</Button>
                            </Col>
                        </Row>}

                    </Card.Body>
                </Card>

                <Card className="my-3">
                    <Card.Header as="h5">Billing history</Card.Header>
                    <Card.Body>
                        <ListInvoice />
                    </Card.Body>
                </Card>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default Billing